import type {
  QuickBooksAccount as QuickBooksAccountProto,
  XeroAccount as XeroAccountProto,
  OtherPlatformConnection as OtherPlatformConnectionProto,
} from '@taxfyle/api-internal/internal/bookkeeping_pb'
import type {
  QuickBooksAccountTypeProps,
  XeroAccountTypeProps,
  OtherAccountTypeProps,
} from '@/features/bookkeeping/platform-connections/BookkeepingPlatformConnection'

export function mapQuickBooksAccountToProps(
  proto: QuickBooksAccountProto,
): QuickBooksAccountTypeProps {
  return {
    type: 'QuickBooks',
    quickBooks: {
      connectionId: proto.getConnectionId(),
      realmId: proto.getRealmId(),
      companyName: proto.getCompanyName(),
    },
  }
}

export function mapXeroAccountToProps(
  proto: XeroAccountProto,
): XeroAccountTypeProps {
  return {
    type: 'Xero',
    xero: {
      connectionId: proto.getConnectionId(),
      tenantId: proto.getTenantId(),
      tenantName: proto.getTenantName(),
    },
  }
}

export function mapOtherPlatformConnectionToProps(
  proto: OtherPlatformConnectionProto,
): OtherAccountTypeProps {
  return { type: 'Other', other: { info: proto.getInfo() } }
}
